export default "__VITE_ASSET__Cp32gmmZ__";